import * as React from "react";
import { cn } from "./utils";

export interface FormImportanceBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
    importance: string;
}

const importanceConfig = {
    essential: {
        color: "bg-red-100 text-red-800 border-red-200",
        label: "Essential",
    },
    common: {
        color: "bg-green-100 text-green-800 border-green-200",
        label: "Common",
    },
    niche: {
        color: "bg-blue-100 text-blue-800 border-blue-200",
        label: "Niche",
    },
    obscure: {
        color: "bg-gray-100 text-gray-800 border-gray-200",
        label: "Obscure",
    },
};

const FormImportanceBadge = React.forwardRef<HTMLSpanElement, FormImportanceBadgeProps>(
    ({ className, importance, ...props }, ref) => {
        const config = importanceConfig[importance.toLowerCase() as keyof typeof importanceConfig];

        if (!config) {
            return (
                <span
                    ref={ref}
                    className={cn(
                        "inline-flex items-center bg-gray-100 px-2 py-1 border border-gray-200 rounded font-medium text-gray-800 text-xs capitalize",
                        className
                    )}
                    {...props}
                >
                    {importance.replace(/_/g, " ")}
                </span>
            );
        }

        return (
            <span
                ref={ref}
                className={cn(
                    "inline-flex items-center px-2 py-1 border rounded font-medium text-xs",
                    config.color,
                    className
                )}
                {...props}
            >
                {config.label}
            </span>
        );
    }
);

FormImportanceBadge.displayName = "FormImportanceBadge";

export { FormImportanceBadge };
